import React, { ReactNode } from "react";

export interface SidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  side?: 'left' | 'right';
}

const SidePanel: React.FC<SidePanelProps> = ({ isOpen, onClose, children, side = 'right' }) => {
  return (
    <div>
      <div
        className={`side-panel ${side === 'left' ? 'side-left' : ''} ${isOpen ? 'open' : ''}`}
        style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}
      >
        
        {/* Fixed Close Button */}
        <div style={{ padding: '16px' }}>
          <button className="side-panel-close-button" onClick={onClose}>X</button>
        </div>

        {/* Scrollable Content */}
        <div
          style={{
            padding: '0 16px 16px 16px',
            overflowY: 'auto',
            flexGrow: 1,
            minHeight: 0,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default SidePanel;
